<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.1.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     viewBox="0 0 50.3 36" style="enable-background:new 0 0 50.3 36;" xml:space="preserve"
     width="50.3" height="36">
<style type="text/css">
	.st0 {
        filter: url(#Adobe_OpacityMaskFilter);
    }

    .st1 {
        fill: #FFFFFF;
    }

    .st2 {
        mask: url(#mask-2_1_);
        fill: none;
        stroke: #000000;
        stroke-width: 1.6;
    }

    .st3 {
        fill: none;
        stroke: #000000;
        stroke-width: 1.6;
        stroke-linecap: round;
        stroke-miterlimit: 4;
    }

    .st5 {
        fill: none;
        stroke: #000000;
        stroke-width: 1.6;
    }
</style>
  <g>
	<g id="Group-3" transform="translate(21.489796, 0.000000)">
		<g id="Oval-7" transform="translate(0.000000, 6.444444)">
			<g id="Mask">
			</g>
          <defs>
				<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="4.9" y="3.2" width="12.7"
                        height="12.9">
					<feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
				</filter>
			</defs>
          <mask maskUnits="userSpaceOnUse" x="4.9" y="3.2" width="12.7" height="12.9" id="mask-2_1_">
				<g class="st0">
					<polygon id="path-1_1_" class="st1"
                             points="6.5,4 9.6,7.3 12.8,13.7 16.8,16.1 20,8.9 17.6,3.2 11.2,1.6 					"/>
				</g>
			</mask>
          <ellipse class="st2" cx="11.2" cy="9.7" rx="5.6" ry="5.6"/>
		</g>
      <path id="Line-10" class="st3" d="M8,5.3l0.7,2.3 M15.6,5.7L14.7,8 M21.2,11l-2.2,1.1 M22.2,18.7l-2.4-0.5"/>
	</g>
    <path class="st5" d="M23.2,11.3c-2,0-3.9,0.7-5.4,1.9c-1.5,1.2-2.6,2.9-3.1,4.9c-0.1,0.3-0.1,0.5-0.2,0.8c-0.3-0.1-0.5-0.1-0.8-0.2
		c-0.3-0.1-0.6-0.1-0.9-0.1c-1.5,0-2.9,0.6-3.9,1.6c-1,1-1.6,2.4-1.6,4s0.6,3,1.6,4c1,1,2.4,1.6,3.9,1.6l20.9,0
		c1.1-0.1,2-0.5,2.7-1.2c0.7-0.7,1.1-1.7,1.1-2.8c0-1.1-0.4-2.1-1.2-2.9c-0.7-0.8-1.8-1.2-3.6-1.2l-0.9,0l0.1-0.9c0-0.2,0-0.5,0-0.8
		c0-2.4-1-4.7-2.6-6.3C27.8,12.3,25.6,11.3,23.2,11.3z"/>
</g>
</svg>
